import { render, staticRenderFns } from "./WorkspaceEvidenceTable.vue?vue&type=template&id=7c82a135&scoped=true"
import script from "./WorkspaceEvidenceTable.vue?vue&type=script&lang=js"
export * from "./WorkspaceEvidenceTable.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceEvidenceTable.vue?vue&type=style&index=0&id=7c82a135&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c82a135",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c82a135')) {
      api.createRecord('7c82a135', component.options)
    } else {
      api.reload('7c82a135', component.options)
    }
    module.hot.accept("./WorkspaceEvidenceTable.vue?vue&type=template&id=7c82a135&scoped=true", function () {
      api.rerender('7c82a135', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceEvidenceTable.vue"
export default component.exports